import { render, staticRenderFns } from "./Istorijat.vue?vue&type=template&id=69e2b4e1&scoped=true"
import script from "./Istorijat.vue?vue&type=script&lang=js"
export * from "./Istorijat.vue?vue&type=script&lang=js"
import style0 from "./Istorijat.vue?vue&type=style&index=0&id=69e2b4e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e2b4e1",
  null
  
)

export default component.exports